$('document').ready(function () {

  if ($('#tutos_v2').length > 0) {

    //Comportement des éléments de la page après un click (coloration des liens
    function handleClickLink(link) {
      $('a').removeClass('active');
      link.toggleClass('active', true);
      var isSubMenu = link.parents('.tutos_ss_menu:first');
      if (isSubMenu.length > 0) {
        $('.panel-heading a[data-tutos]', '#tutos_menu').toggleClass('active', false);
        var sectionLink = isSubMenu.parents('.panel:first').find('.panel-heading a[data-tutos]');
        sectionLink.toggleClass('active', true);
      }
      if ( link.attr('role')) {
        link.closest('.panel-default').find('.tutos_ss_menu:first a:first').toggleClass('active', true);
      }
    }

    //Ici on gère le changement de contenu lors du clic sur
    //un lien présent dans le menu
    $('#tutos_menu a').click(function () {
      handleClickLink($(this));
      $('#tutos_content .tutos_section:visible').hide();
      var id = $(this).data('tutos');
      $('#'+id).show();
      //si on est pas dans une sous liste donc déjà ouverte on ouvre le nouveau menu
      if (!$(this).parents('.collapse').hasClass('in')) {
        $('.collapse').collapse('hide');
        $('[data-tutos='+id+']', '#tutos_menu').closest('.panel-collapse').collapse('toggle');
      }
      if ($('#isMobile').is(':hidden')) {
        window.scrollTo(0, 0);
      } else {
        $('html, body').animate({
          scrollTop: ($('#ancre').offset().top)
        },250);}
    });

    //Cette partie a été ajoutée pour prendre en compte les
    //liens qui sont dans le contenu
    $('.tutos_section a:not([rel="external"])', '#tutos_v2').click(function () {
      var id = $(this).data('tutos');
      $('[data-tutos='+id+']', '#tutos_menu').trigger('click');
    });

    //Mise en couleur des élements affichés au chargement de la page
    $('.tutos_ss_menu:first a:first').trigger('click');

  }
});
